import React, {useEffect} from "react";

import bg from "../../assets/hero_section_bg_enterprise_.webp";
import front from "../../assets/hero_section_front_enterprise_.webp";
import truckBg from "../../assets/drivers_bg.webp";
import truck from "../../assets/truck.webp";
import "../../Css/DriverPartnerLogin.css";
import girl1 from "../../assets/e_commerce_1.webp"
import driver3 from "../../assets/_mtjd_loyalty_rewards.webp"
import driver from "../../assets/Services_2.webp"
import driver2 from "../../assets/e_commerce_2.webp"
import driver4 from "../../assets/insurnace_coverage_.webp"
import girl2 from "../../assets/CS 1.webp"

function DriverSection3() {

  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
<section className="section3 relative overflow-hidden">
  {/* Background image */}
  <img src={truckBg} alt="Background" className="background" />

  {/* Foreground content */}
  <div className="content-parent flex flex-col gap-8 px-2 py-10 md:px-4 lg:flex-row lg:justify-between lg:gap-8">
    
    <div
      style={{
        zIndex: 6,
        position: "relative",
      }}
      className="m-0 flex w-full min-w-0 flex-col items-center justify-center overflow-hidden p-2 text-center lg:min-w-[300px]"
    >
      <h1 className="font-[500] text-[22px] md:text-[28px] lg:text-[28px] text-[#212529]">
        What Our Driver Partner Say
      </h1>

      <p className="custom-paragraph m-0 mb-5 pt-4 lg:text-[22px] font-[400] text-[#212529]">
        Hear how Packky is helping drivers earn better everyday
      </p>

      <img src={truck} alt="" className="truck-img max-w-full" />
    </div>

    {/* 1st column */}
<div className="card-column1-parent w-full overflow-hidden lg:min-h-[420px] lg:max-w-[320px]">
 <div className="queue-track flex flex-row-reverse w-max gap-4 pb-2 md:gap-8 lg:w-auto lg:flex-col lg:gap-12">
    
   
      {[...Array(2)].map((_, repeatIndex) => (
  <React.Fragment key={repeatIndex}>
        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={girl1}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Kiara Bhatt
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>
           <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={girl1}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Shivani Bhatt
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>
           <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={girl1}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Kiara Bhatt
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={front}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Ajay Gupta
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={girl2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Saanvi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        
        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Rehan Oberoi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        
        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Rehan Oberoi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>
        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Rehan Oberoi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>
      </React.Fragment>
))}
  </div>
</div>

    {/* 2nd column */}
   <div className="card-column2-parent w-full overflow-hidden lg:min-h-[420px] lg:max-w-[320px]">
 <div className="queue-track-2 flex w-max gap-4 pb-2 md:gap-8 lg:w-auto lg:flex-col lg:gap-12">

     {[...Array(2)].map((_, repeatIndex) => (
  <React.Fragment key={repeatIndex}>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Rehan Oberoi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>
        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Rehan Oberoi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        
        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Rehan Oberoi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>
        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver2}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Rehan Oberoi
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver3}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Yuvan Aggarwal
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Aarav Sharma
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

        <div
          className="box flex min-w-[250px] lg:min-w-0 flex-col gap-2 rounded p-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            minHeight: "100px",
            border: "1px solid white",
          }}
        >
          <div className="flex gap-3">
            <img
              src={driver4}
              alt="profile pic"
              className="h-[55px] w-[55px] rounded-full object-cover"
            />

            <div className="flex flex-col items-start justify-center gap-1">
              <h5 className="mb-0 text-lg font-semibold sm:text-xl text-[#212529]">
                Ajay Gupta
              </h5>
              <p className="mb-0 text-sm sm:text-base text-[#212529]">
                Packky Driver Partner
              </p>
            </div>
          </div>

          <p className="mb-0 text-sm text-[#555] sm:text-[0.95rem]">
            "Packky helps me earn daily without the stress. The app is smooth,
            and payments are always on time."
          </p>
        </div>

      </React.Fragment>
  ))}
  </div>
</div>
  </div>
</section>

    );
}

export default DriverSection3;